import { ChangeDetectionStrategy, Component } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: "dtm-main-page-lib-campaign-media",
    templateUrl: "./campaign-media.component.html",
    styleUrls: ["./campaign-media.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignMediaComponent {}
